import React from "react";
import Style from "./ChangeFactorTable.module.css";
import { Table, Tooltip } from "antd";
import "../../Pages/ManageCustomer/ManageCustomer.css";
import { PencilSquare, ArrowRepeat } from "react-bootstrap-icons";

const ChangeFactorTable = ({ btnHandler, data }) => {
  const columns = [
    {
      title: "نام محصول",
      dataIndex: "name",
      key: "name",
      width: "35%",
      render: (text, record) => {
        const isAvailable = record.available === "1" || record.available === 1;
        return (
          <div className={Style.productCell}>
            <span
              className={`${Style.productName} ${
                !isAvailable ? Style.strikethrough : ""
              }`}
            >
              {text}
            </span>
            {record.isModified && (
              <span className={Style.modifiedBadge}>تغییر یافته</span>
            )}
            {!isAvailable && (
              <span className={Style.unavailableTag}>ناموجود</span>
            )}
          </div>
        );
      },
    },
    {
      title: "تعداد",
      dataIndex: "newCount",
      key: "newCount",
      width: "20%",
      render: (text, record) => {
        const isAvailable = record.available === "1" || record.available === 1;
        const countChanged = String(record.newCount) !== String(record.count);

        if (!isAvailable) {
          return <span className={Style.unavailableText}>ناموجود در فاکتور</span>;
        }

        return (
          <div className={Style.countCell}>
            <span className={Style.countCurrent}>{text} عدد</span>
            {countChanged && (
              <span className={Style.countOriginal}>
                (قبلی: {record.count})
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: "قیمت واحد",
      dataIndex: "newPrice",
      key: "newPrice",
      width: "25%",
      render: (text, record) => {
        const isAvailable = record.available === "1" || record.available === 1;
        const priceChanged = String(record.newPrice) !== String(record.price);

        return (
          <div className={Style.priceCell}>
            <span
              className={`${Style.priceCurrent} ${
                !isAvailable ? Style.strikethrough : ""
              }`}
            >
              {text} تومان
            </span>
            {priceChanged && (
              <span className={Style.priceOriginal}>
                (قبلی: {record.price} تومان)
              </span>
            )}
          </div>
        );
      },
    },
    {
      title: "عملیات",
      dataIndex: "orderBtn",
      key: "orderBtn",
      width: "20%",
      render: (text, record) => {
        const isAvailable = record.available === "1" || record.available === 1;

        return (
          <div className={Style.btnHolder}>
            <Tooltip title="ویرایش قیمت، تعداد و وضعیت موجودی">
              <button
                type="button"
                onClick={() => btnHandler(1, record)}
                className={Style.changeBtn}
              >
                <PencilSquare />
                <span>مشخصه</span>
              </button>
            </Tooltip>

            <Tooltip title="جایگزینی کالا با محصولی دیگر از انبار">
              <button
                type="button"
                onClick={() => btnHandler(2, record)}
                className={`${Style.replaceBtn} ${
                  !isAvailable ? Style.replaceBtnActive : ""
                }`}
              >
                <ArrowRepeat />
                <span>جایگزینی</span>
              </button>
            </Tooltip>
          </div>
        );
      },
    },
  ];

  return (
    <div className={Style.tableWrapper}>
      <Table
        pagination={false}
        columns={columns}
        size="middle"
        dataSource={data}
        responsive={true}
        loading={data === undefined}
        rowClassName={(record) =>
          record.isModified ? Style.modifiedRow : ""
        }
      />
    </div>
  );
};

export default ChangeFactorTable;
